import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/Admin/AdminLayout';
import Home from './pages/Home';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import CountriesList from './components/Countries/CountriesList';
import SelfieEditor from './selfie-editor/SelfieEditor';
import PrintLayout from './selfie-editor/components/PrintLayout';
import PassportCountries from './selfie-editor/components/PassportCountries';
import BlogList from './components/Blog/BlogList';
import BlogDetail from './components/Blog/BlogDetail';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminBlogEditor from './components/Admin/AdminBlogEditor';
import ProtectedRoute from './components/Admin/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="blogs/new" element={<AdminBlogEditor />} />
          <Route path="blogs/edit/:id" element={<AdminBlogEditor />} />
        </Route>

        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="contact" element={<Contact />} />
          <Route path="terms" element={<Terms />} />
          <Route path="countries" element={<CountriesList />} />
          <Route path="blog" element={<BlogList />} />
          <Route path="blog/:slug" element={<BlogDetail />} />
          <Route path="features" element={<SelfieEditor />} />
          <Route path="photo-editor" element={<SelfieEditor />} />
          <Route path="print-layout" element={<PrintLayout />} />
          <Route path="passport-sizes" element={<PassportCountries />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
